import React from "react";
import styled from "styled-components";
import { HealthShield } from "./MainContent/HealthShield";
import { SafetyCommitment } from "./MainContent/SafetyCommitment";

export function MainContent({ hideModal }) {
  return (
    <ScrollableDiv>
      <ContactlessInformationalBody>
        <HealthShield />
        <SafetyCommitment hideModal={hideModal} />
      </ContactlessInformationalBody>
    </ScrollableDiv>
  );
}

const ScrollableDiv = styled.div`
  overflow-y: auto;
`;

const ContactlessInformationalBody = styled.div`
  background-color: ${(props) => props.theme.color.white};
  padding-top: ${(props) => props.theme.spacing.lg};
  padding-bottom: 0;
  padding-left: ${(props) => props.theme.spacing.lg};
  padding-right: ${(props) => props.theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: stretch;

  ${(props) => props.theme.breakpoints.lgDesktopUp} {
    padding-bottom: ${(props) => props.theme.spacing.lg};
    flex-direction: row;
    padding-top: ${(props) => props.theme.spacing.xxxxl};
  }
`;
